import { create } from 'zustand';
import { persist } from 'zustand/middleware';

function generateId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

function hashFingerprint(input: string): string {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return `fp_${Math.abs(hash).toString(36)}`;
}

function buildFingerprint(): string {
  const parts = [
    navigator.userAgent,
    navigator.language,
    screen.width,
    screen.height,
    screen.colorDepth,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  ];
  return hashFingerprint(parts.join('|'));
}

interface VisitorState {
  visitorFingerprint: string;
  sessionId: string;
  interestTags: string[];
  init: () => void;
  addInterest: (tag: string) => void;
  resetSession: () => void;
}

export const useVisitorStore = create<VisitorState>()(
  persist(
    (set, get) => ({
      visitorFingerprint: '',
      sessionId: '',
      interestTags: [],

      init: () => {
        const state = get();
        const fingerprint =
          state.visitorFingerprint || buildFingerprint();
        const sessionId = state.sessionId || generateId();

        set({
          visitorFingerprint: fingerprint,
          sessionId,
        });
      },

      addInterest: (tag: string) => {
        const normalized = tag.trim().toLowerCase();
        if (!normalized) return;
        const current = get().interestTags;
        if (current.includes(normalized)) return;
        set({ interestTags: [...current, normalized] });
      },

      resetSession: () => {
        set({ sessionId: generateId() });
      },
    }),
    {
      name: 'qrb-visitor',
      partialize: (state) => ({
        visitorFingerprint: state.visitorFingerprint,
        interestTags: state.interestTags,
      }),
    },
  ),
);
